import { useAppSelector } from "../../Store";
import { useAuthStore } from "../../Store/Slices/AuthSlice";

export const useMMLiteEnablement = () => {
  const { userConfig } = useAppSelector(useAuthStore);

  // If no config, enable by default
  if (!userConfig) return true;

  const payload = userConfig.payload;

  // If payload is missing or key does not exist → return true
  if (!payload || !Object.prototype.hasOwnProperty.call(payload, 'is_mm_lite_onboarded')) {
    return true;
  }

  // Otherwise return the actual value
  return payload.is_mm_lite_onboarded;
};

